import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Utils from '_utils';
import * as Common from '_common';
import * as Styles from './ProgressBar.module.scss';
export var ProgressDirection;
(function (ProgressDirection) {
    ProgressDirection[ProgressDirection["LeftToRight"] = 0] = "LeftToRight";
    ProgressDirection[ProgressDirection["RightToLeft"] = 1] = "RightToLeft";
    ProgressDirection[ProgressDirection["TopToBottom"] = 2] = "TopToBottom";
    ProgressDirection[ProgressDirection["BottomToTop"] = 3] = "BottomToTop";
})(ProgressDirection || (ProgressDirection = {}));
export var ProgressSize;
(function (ProgressSize) {
    ProgressSize[ProgressSize["Small"] = 0] = "Small";
    ProgressSize[ProgressSize["Normal"] = 1] = "Normal";
    ProgressSize[ProgressSize["Big"] = 2] = "Big";
})(ProgressSize || (ProgressSize = {}));
export var ProgressBarDecoration;
(function (ProgressBarDecoration) {
    ProgressBarDecoration[ProgressBarDecoration["None"] = 0] = "None";
    ProgressBarDecoration[ProgressBarDecoration["Percent"] = 1] = "Percent";
    ProgressBarDecoration[ProgressBarDecoration["Value"] = 2] = "Value";
    ProgressBarDecoration[ProgressBarDecoration["Custom"] = 3] = "Custom";
})(ProgressBarDecoration || (ProgressBarDecoration = {}));
export function RenderProgress(component, index) {
    const value = Number.parseInt(component.properties.value);
    const max = Number.parseInt(component.properties.max);
    let direction = undefined;
    if (component.properties.direction) {
        const dir = component.properties.direction.toLowerCase();
        if (dir === ProgressDirection[ProgressDirection.LeftToRight].toLowerCase()) {
            direction = ProgressDirection.LeftToRight;
        }
        else if (dir === ProgressDirection[ProgressDirection.RightToLeft].toLowerCase()) {
            direction = ProgressDirection.RightToLeft;
        }
        else if (dir === ProgressDirection[ProgressDirection.TopToBottom].toLowerCase()) {
            direction = ProgressDirection.TopToBottom;
        }
        else if (dir === ProgressDirection[ProgressDirection.BottomToTop].toLowerCase()) {
            direction = ProgressDirection.BottomToTop;
        }
    }
    let size = undefined;
    if (component.properties.size) {
        const sz = component.properties.size.toLowerCase();
        if (sz === ProgressSize[ProgressSize.Small].toLowerCase()) {
            size = ProgressSize.Small;
        }
        else if (sz === ProgressSize[ProgressSize.Normal].toLowerCase()) {
            size = ProgressSize.Normal;
        }
        else if (sz === ProgressSize[ProgressSize.Big].toLowerCase()) {
            size = ProgressSize.Big;
        }
    }
    let decoration = undefined;
    if (component.properties.decoration) {
        const dec = component.properties.decoration.toLowerCase();
        if (dec === ProgressBarDecoration[ProgressBarDecoration.Percent].toLowerCase()) {
            decoration = ProgressBarDecoration.Percent;
        }
        else if (dec === ProgressBarDecoration[ProgressBarDecoration.Value].toLowerCase()) {
            decoration = ProgressBarDecoration.Value;
        }
        else if (dec === ProgressBarDecoration[ProgressBarDecoration.Custom].toLowerCase()) {
            decoration = ProgressBarDecoration.Custom;
        }
    }
    return (_jsx(Progress, { value: value, max: max, direction: direction, size: size, decoration: decoration }, index));
}
export function Progress(props) {
    const direction = props.direction ?? ProgressDirection.LeftToRight;
    const size = props.size ?? ProgressSize.Normal;
    function getDecoration() {
        if (props.decoration) {
            return props.decoration;
        }
        if (props.customSigns && props.customSigns.length > 0) {
            return ProgressBarDecoration.Custom;
        }
        if (props.valueText) {
            return ProgressBarDecoration.Value;
        }
        if (props.max === 100) {
            return ProgressBarDecoration.Percent;
        }
        return ProgressBarDecoration.None;
    }
    const decoration = getDecoration();
    const style = {
        '--value': (props.value / props.max) * 100 + '%',
    };
    function createSigns() {
        const signs = [];
        function addSign(value, text) {
            const style = { '--value': value + '%' };
            signs.push(_jsx("div", { className: Styles.sign, style: style, children: _jsx("span", { children: text }) }, value));
        }
        if (decoration === ProgressBarDecoration.Percent) {
            if (size === ProgressSize.Normal) {
                for (let i = 25; i <= 75; i += 25) {
                    addSign(i, null);
                }
                addSign(props.value, props.value + '%');
            }
            if (size === ProgressSize.Big) {
                for (let i = 10; i <= 90; i += 10) {
                    addSign(i, i + '%');
                }
            }
        }
        if (decoration === ProgressBarDecoration.Value) {
            if (props.valueText) {
                addSign(50, props.valueText);
            }
            else {
                addSign(50, props.value + '/' + props.max);
            }
        }
        if (decoration === ProgressBarDecoration.Custom && props.customSigns) {
            props.customSigns.forEach(sign => {
                addSign(sign.value, sign.text ?? sign.value.toString());
            });
        }
        return signs;
    }
    const classNames = {
        [Styles.direction_leftToRight]: direction === ProgressDirection.LeftToRight,
        [Styles.direction_rightToLeft]: direction === ProgressDirection.RightToLeft,
        [Styles.direction_topToBottom]: direction === ProgressDirection.TopToBottom,
        [Styles.direction_bottomToTop]: direction === ProgressDirection.BottomToTop,
        [Styles.size_small]: size === ProgressSize.Small,
        [Styles.size_normal]: size === ProgressSize.Normal,
        [Styles.size_big]: size === ProgressSize.Big,
    };
    const signs = createSigns();
    function onMouseUp(e) {
        if (props.onClick) {
            const rect = e.currentTarget.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const value = Math.round((x / rect.width) * props.max);
            props.onClick(value);
        }
    }
    return (_jsxs(Common.Component, { name: 'progress', className: Utils.classNames(classNames), onMouseUp: onMouseUp, children: [_jsx("div", { className: Styles.bar, style: style }), signs] }));
}
